import React from 'react';
import { Shield, Lock, ChevronRight } from 'lucide-react';

export default function Datenschutz() {
  const sections = [
    {
      icon: Shield,
      title: "Haftung für Inhalte",
      items: [
        "Trotz sorgfältiger Bearbeitung kann keine Gewähr für die Richtigkeit und Vollständigkeit der in dieser Website enthaltenen Daten übernommen werden.",
        "Die Betreiber der Seiten haben keinen Einfluss auf die Gestaltung und den Inhalt von anderen Webseiten, auf die mit einem Link verwiesen wird. Für diese fremden Inhalte wird daher keine Verantwortung übernommen."
      ]
    },
    {
      icon: Lock,
      title: "Datenschutz",
      items: [
        "Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies stets auf freiwilliger Basis.",
        "Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.",
        "Die Datenübertragung im Internet kann Sicherheitslücken aufweisen. Ein lückenloser Schutz der Daten vor Zugriffen Dritter ist nicht möglich.",
        "Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Rechtliche Schritte bei unerwünschter Werbung bleiben vorbehalten."
      ]
    }
  ];

  return (
    <section className="services">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Datenschutz & Haftung</h2>
          <p className="section-description">
            Hier finden Sie alle wichtigen Informationen zu Datenschutz und Haftung auf unserer Webseite.
          </p>
        </div>

        <div className="services-grid">
          {sections.map((section, index) => {
            const IconComponent = section.icon;
            return (
              <div key={index} className="service-card">
                <div className="service-icon">
                  <IconComponent color="white" size={32} />
                </div>

                <h3 className="service-title">{section.title}</h3>

                <ul className="service-list">
                  {section.items.map((item, i) => (
                    <li key={i}>
                      <ChevronRight className="service-list-icon" size={24} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
